var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneratorInchis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 25C2.5 27.9547 3.08198 30.8806 4.21271 33.6104C5.34344 36.3402 7.00078 38.8206 9.0901 40.9099C11.1794 42.9992 13.6598 44.6566 16.3896 45.7873C19.1194 46.918 22.0453 47.5 25 47.5C27.9547 47.5 30.8806 46.918 33.6104 45.7873C36.3402 44.6566 38.8206 42.9992 40.9099 40.9099C42.9992 38.8206 44.6566 36.3402 45.7873 33.6104C46.918 30.8806 47.5 27.9547 47.5 25C47.5 22.0453 46.918 19.1194 45.7873 16.3896C44.6566 13.6598 42.9992 11.1794 40.9099 9.0901C38.8206 7.00078 36.3402 5.34344 33.6104 4.21271C30.8806 3.08198 27.9547 2.5 25 2.5C22.0453 2.5 19.1194 3.08198 16.3896 4.21271C13.6598 5.34344 11.1794 7.00078 9.0901 9.0901C7.00078 11.1794 5.34344 13.6598 4.21271 16.3896C3.08198 19.1194 2.5 22.0453 2.5 25Z",
    stroke: "#FF2E00",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15H25C23.6739 15 22.4021 15.5268 21.4645 16.4645C20.5268 17.4021 20 18.6739 20 20V30C20 31.3261 20.5268 32.5979 21.4645 33.5355C22.4021 34.4732 23.6739 35 25 35H30V25H27.5",
    stroke: "#FF2E00",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneratorInchis);
export default __webpack_public_path__ + "static/media/generator-inchis.78f317eb8b883cdc1604d76324b6737d.svg";
export { ForwardRef as ReactComponent };